export default {
  NAME_NETHERLANDS: 'MODIFI B.V.',

  CONTACT_CHINA_WE_CHAT_ID: 'modifichina',
}
